export const STRING = 'String';
